var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { dia, shapes } from '@joint/plus';
import { VisioArchive, types } from '@joint/format-visio';
var VisioSectionType = types.VisioSectionType;
var bpmn2 = shapes.bpmn2, standard = shapes.standard;
export var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    function renderPage(pageId) {
        return __awaiter(this, void 0, void 0, function () {
            var page, pageContent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appEl.classList.add('loading');
                        Array.from(navigationEl.childNodes).forEach(function (pageEl) {
                            pageEl.classList.toggle('active', Number(pageEl.dataset.pageId) === pageId);
                        });
                        page = vsdDocument.getPage(pageId);
                        paper.setDimensions(page.width, page.height);
                        return [4 /*yield*/, page.getContent()];
                    case 1:
                        pageContent = _a.sent();
                        appEl.classList.remove('loading');
                        renderPageContent(pageContent);
                        return [2 /*return*/];
                }
            });
        });
    }
    function renderPageContent(pageContent) {
        var cells = pageContent.toGraphCells({
            importShape: function (vsdShape) {
                var element;
                var fontSize = 10;
                var data = vsdShape.getComputedSection(VisioSectionType.Property);
                if (!data)
                    return null;
                var shapeName = data.getProperty('BpmnElementType');
                // Element Type
                switch (shapeName) {
                    case 'Event': {
                        element = new bpmn2.Event();
                        var eventType = data.getProperty('BpmnEventType');
                        var icon = (data.getProperty('BpmnTriggerOrResult') || 'none').toLowerCase();
                        var iconType = {
                            'none': 'none',
                            'message': 'message1',
                            'terminate': 'termination1',
                            'timer': 'timer1',
                            'error': 'error1',
                            'cancel': 'cancel1',
                            'compensation': 'compensation1',
                            'conditional': 'conditional1',
                            'link': 'link1',
                            'signal': 'signal1',
                            'multiple': 'multiple1',
                            'escalation': 'escalation1',
                            'parallel multiple': 'parallel1',
                        }[icon];
                        var iconType2 = {
                            'none': 'none',
                            'message': 'message2',
                            'terminate': 'termination2',
                            'timer': 'timer2',
                            'error': 'error2',
                            'cancel': 'cancel2',
                            'compensation': 'compensation2',
                            'conditional': 'conditional2',
                            'link': 'link2',
                            'signal': 'signal2',
                            'multiple': 'multiple2',
                            'escalation': 'escalation2',
                            'parallel multiple': 'parallel2',
                        }[icon];
                        switch (eventType) {
                            case 'Start': {
                                element.attr('border/borderStyle', 'solid');
                                element.attr('icon/iconType', iconType);
                                break;
                            }
                            case 'Start (Non-Interrupting)': {
                                element.attr('border/borderStyle', 'dashed');
                                element.attr('icon/iconType', iconType);
                                break;
                            }
                            case 'Intermediate': {
                                element.attr('border/borderStyle', 'solid');
                                element.attr('border/borderType', 'double');
                                element.attr('icon/iconType', iconType);
                                break;
                            }
                            case 'Intermediate (Non-Interrupting)': {
                                element.attr('border/borderStyle', 'dashed');
                                element.attr('border/borderType', 'double');
                                element.attr('icon/iconType', iconType);
                                break;
                            }
                            case 'Intermediate (Throwing)': {
                                element.attr('border/borderStyle', 'solid');
                                element.attr('border/borderType', 'double');
                                element.attr('icon/iconType', iconType2);
                                break;
                            }
                            case 'End': {
                                element = new bpmn2.Event();
                                element.attr('border/borderType', 'thick');
                                element.attr('icon/iconType', iconType2);
                                break;
                            }
                        }
                        break;
                    }
                    case 'Artifact': {
                        var bpmnType = (data.getProperty('BpmnArtifactType') || '').toLowerCase();
                        switch (bpmnType) {
                            case 'data object': {
                                element = new bpmn2.DataObject();
                                var collection = data.getProperty('BpmnCollection'); // 0 or 1
                                if (collection === '1') {
                                    element.attr('collectionIcon/collection', 'true');
                                }
                                break;
                            }
                            case 'group': {
                                element = new bpmn2.Group();
                                break;
                            }
                            case 'annotation': {
                                element = new bpmn2.Annotation();
                                fontSize = 13;
                                break;
                            }
                            default: {
                                element = new bpmn2.DataStore();
                                break;
                            }
                        }
                        break;
                    }
                    case 'Sub-Process':
                    case 'Task': {
                        element = new bpmn2.Activity();
                        var boundaryType = data.getProperty('BpmnBoundaryType');
                        var activityType = data.getProperty('BpmnTaskType');
                        var isCollapsed = data.getProperty('BpmnIsCollapsed') === '1';
                        // markers
                        var markers = [];
                        var loopType = data.getProperty('BpmnLoopType');
                        var isAdHoc = data.getProperty('BpmnAdHoc') === '1';
                        var isForCompensation = data.getProperty('BpmnIsForCompensation') === '1';
                        // task icon
                        if (!isCollapsed && activityType) {
                            // Available Task Types
                            // data.getProperty('BpmnTaskType', 'format').split(';');
                            var icon = activityType.toLowerCase();
                            var iconType = {
                                'receive': 'receive',
                                'service': 'service',
                                'send': 'send',
                                'manual': 'manual',
                                'user': 'user',
                                'none': 'none',
                                'script': 'script',
                                'business rule': 'business-rule',
                                'instantiating receive': 'receive'
                            }[icon];
                            element.attr('icon/iconType', iconType);
                        }
                        // markers
                        switch (loopType) {
                            case 'Standard': {
                                markers.push('loop');
                                break;
                            }
                            case 'Parallel MultiInstance': {
                                markers.push('parallel');
                                break;
                            }
                            case 'Sequential MultiInstance': {
                                markers.push('sequential');
                                break;
                            }
                        }
                        if (isForCompensation && !markers.find(function (m) { return m === 'compensation'; })) {
                            markers.push('compensation');
                        }
                        if (isCollapsed && !markers.find(function (m) { return m === 'sub-process'; })) {
                            markers.push('sub-process');
                        }
                        if (isAdHoc) {
                            markers.push('ad-hoc');
                        }
                        element.attr('markers/iconTypes', markers);
                        switch (boundaryType) {
                            case 'Call': {
                                element.attr('border/borderType', 'thick');
                                break;
                            }
                            case 'Transaction': {
                                element.attr('border/borderType', 'double');
                                break;
                            }
                            case 'Event': {
                                element.attr('border/borderStyle', 'dotted');
                                break;
                            }
                            case 'Default':
                            default: {
                                element.attr('border/borderType', 'single');
                                break;
                            }
                        }
                        break;
                    }
                    case 'Expanded Sub-Process': {
                        element = new bpmn2.Activity();
                        break;
                    }
                    case 'Gateway': {
                        element = new bpmn2.Gateway();
                        var gatewayType = data.getProperty('BpmnGatewayType');
                        var isMarkerVisible = data.getProperty('BpmnMarkerVisible') === '1';
                        var exclusiveType = data.getProperty('BpmnExclusiveType');
                        if (gatewayType) {
                            // Available Gateway Types
                            // data.getProperty('BpmnGatewayType', 'format').split(';');
                            var iconType = {
                                'Exclusive': 'exclusive',
                                'Exclusive Event (Instantiate)': 'exclusive_event',
                                'Inclusive': 'inclusive',
                                'Parallel': 'parallel',
                                'Parallel Event (Instantiate)': 'parallel_event',
                                'Complex': 'complex'
                            }[gatewayType];
                            element.attr('icon/iconType', iconType);
                        }
                        if (exclusiveType === 'Data' && gatewayType === 'Exclusive' && !isMarkerVisible) {
                            element.attr('icon/iconType', 'none');
                        }
                        if (exclusiveType === 'Event' && gatewayType === 'Exclusive') {
                            element.attr('icon/iconType', 'event');
                        }
                        break;
                    }
                    default: {
                        element = new standard.Rectangle();
                        break;
                    }
                }
                // Element Name
                var name = data.getProperty('BpmnName');
                if (name) {
                    element.attr('label/text', name);
                    element.attr('label/fontSize', fontSize);
                }
                // Size & Position
                var _a = vsdShape.getPageBBox(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
                element.set({
                    position: { x: x, y: y },
                    size: { width: width, height: height },
                    z: 2
                });
                return element;
            },
            importConnect: function (vsdConnect, sourceElement, targetElement) {
                var link;
                var vsdShape = vsdConnect.getShape();
                var data = vsdShape.getComputedSection(VisioSectionType.Property);
                var connectionObjectType = (data.getProperty('BpmnConnectingObjectType') || '').toLowerCase();
                switch (connectionObjectType) {
                    case 'sequence flow': {
                        link = new bpmn2.Flow();
                        var conditionType = data.getProperty('BpmnConditionType');
                        if (conditionType) {
                            // Available Condition Types
                            // data.getProperty('BpmnConnectingObjectType', 'format').split(';');
                            var FLOW_TYPES = bpmn2.Flow.FLOW_TYPES;
                            var flowType = {
                                'Default': FLOW_TYPES.default,
                                'Expression': FLOW_TYPES.conditional,
                                'None': FLOW_TYPES.sequence
                            }[conditionType];
                            link.attr('line/flowType', flowType);
                        }
                        break;
                    }
                    case 'association': {
                        link = new bpmn2.DataAssociation();
                        var sourceBBox = sourceElement.getBBox();
                        var side = sourceBBox.sideNearestToPoint(targetElement.getBBox().center());
                        var direction = data.getProperty('BpmnDirection');
                        switch (direction) {
                            case 'None': {
                                link.attr('line/targetMarker', null);
                                break;
                            }
                            case 'One': {
                                break;
                            }
                            case 'Both': {
                                link.attr('line/sourceMarker', {
                                    'type': 'path',
                                    'd': 'M 10 -7 0 0 10 7',
                                    'stroke-width': 2,
                                    'fill': 'none'
                                });
                                break;
                            }
                        }
                        switch (side) {
                            case 'top': {
                                sourceElement.attr('border/annotationD/side', 'top');
                                sourceElement.attr('label/textAnchor', 'middle');
                                sourceElement.attr('label/refX', '50%');
                                break;
                            }
                            case 'right': {
                                sourceElement.attr('border/annotationD/side', 'right');
                                sourceElement.attr('label/textAnchor', 'end');
                                sourceElement.attr('label/refX', '100%');
                                sourceElement.attr('label/refX2', '-4');
                                break;
                            }
                            case 'bottom': {
                                sourceElement.attr('border/annotationD/side', 'bottom');
                                sourceElement.attr('label/textAnchor', 'middle');
                                sourceElement.attr('label/textVerticalAnchor', 'bottom');
                                sourceElement.attr('label/refX', '50%');
                                sourceElement.attr('label/refY', '100%');
                                sourceElement.attr('label/refY2', '-6');
                                break;
                            }
                            case 'left':
                            default: {
                                sourceElement.attr('border/annotationD/side', 'left');
                                sourceElement.attr('label/textAnchor', 'start');
                                break;
                            }
                        }
                        break;
                    }
                    case 'message flow': {
                        link = new bpmn2.Flow();
                        link.attr('line/flowType', 'message');
                        break;
                    }
                    default: {
                        link = new standard.Link();
                        break;
                    }
                }
                var vertices = vsdConnect.toLinkAttributes(sourceElement, targetElement).vertices;
                link.set({
                    vertices: vertices,
                    source: { id: sourceElement.id },
                    target: { id: targetElement.id },
                    z: 1
                });
                return link;
            },
            importLabels: function (vsdShape, link) {
                var data = vsdShape.getComputedSection(VisioSectionType.Property);
                var name = data.getProperty('BpmnName');
                if (name) {
                    link.appendLabel({
                        attrs: {
                            body: {
                                fill: '#F4F7F6'
                            },
                            label: {
                                text: name,
                                fontWeight: 'bold',
                                fontSize: 10
                            }
                        },
                        position: 0.5
                    });
                }
                return [];
            }
        });
        graph.resetCells(cells);
        paper.unfreeze();
    }
    var navigationEl, paperEl, appEl, graph, paper, vsdDocument, page0;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                navigationEl = document.getElementById('navigation');
                paperEl = document.getElementById('paper');
                appEl = document.body;
                graph = new dia.Graph();
                paper = new dia.Paper({
                    el: paperEl,
                    width: 1000,
                    height: 1000,
                    drawGrid: true,
                    model: graph,
                    interactive: { linkMove: false },
                    async: true,
                    frozen: true,
                });
                return [4 /*yield*/, VisioArchive.fromURL('./assets/bpmn.vsdx')];
            case 1:
                vsdDocument = (_a.sent()).document;
                vsdDocument.getPages().forEach(function (page) {
                    var pageEl = document.createElement('li');
                    pageEl.textContent = page.name;
                    pageEl.dataset.pageId = "".concat(page.id);
                    navigationEl.appendChild(pageEl);
                });
                navigationEl.addEventListener('click', function (_a) {
                    var target = _a.target;
                    if (navigationEl === target)
                        return;
                    renderPage(Number(target.dataset.pageId));
                });
                page0 = vsdDocument.getPages()[0];
                renderPage(page0.id);
                return [2 /*return*/];
        }
    });
}); };
